import Vue from 'vue'

const URL_ROOT = '/api';
const GET_PARAM = '?' + Math.random();

const state = {
    questions: [],
    testResult: false
};

const actions = {

	GET_STATUS_TEST({commit, state, rootGetters}) {
		return new Promise((resolve, reject) => {
			Vue.http.get(rootGetters['GET_URL_ROOT'] + URL_ROOT + '/test/get'+GET_PARAM).then(
				(response) => {
					resolve();
				},
				(error) => {
					reject(error.body.message);
				})
		})
	},

    GET_QUESTIONS({commit, state, rootGetters}) {
        return new Promise((resolve, reject) => {
            Vue.http.get(rootGetters['GET_URL_ROOT'] + URL_ROOT + '/test/get'+GET_PARAM).then(
                (response) => {
                    commit('CLEAR_QUESTIONS');
                    commit('UPDATE_QUESTIONS', response.body);
                    resolve();
                },
                (error) => {
                    reject(error.body.message);
                })
        })
    },

    START_TEST({commit, state, rootGetters}) {
        return new Promise((resolve, reject) => {
            Vue.http.get(rootGetters['GET_URL_ROOT'] + URL_ROOT + '/test/start').then(
                () => {
                    resolve();
                },
                () => {
                    reject();
                })
        })
    },

    SEND_ANSWER({commit, state, rootGetters}, id) {
        return new Promise((resolve, reject) => {
            Vue.http.get(rootGetters['GET_URL_ROOT'] + URL_ROOT + '/test/answer?id=' + id).then(
                (response) => {
                    resolve(response.body);
                },
                () => {
                    reject();
                })
        })
    },

    END_TEST({commit, state, rootGetters}) {
        return new Promise((resolve, reject) => {
            Vue.http.get(rootGetters['GET_URL_ROOT'] + URL_ROOT + '/test/end').then(
                (response) => {
                    commit('UPDATE_TEST_RESULT', response.body);
                    resolve(response.body);
                },
                () => {
                    reject();
                })
        })
    }
};

const getters = {

    GET_QUESTIONS: state => state.questions,

    GET_TEST_RESULT: state => state.testResult

};

const mutations = {

    UPDATE_QUESTIONS(State, data) {
        State.questions = State.questions.concat(data);
    },

    UPDATE_TEST_RESULT(State, data) {
        let time = {
            min: parseInt(parseInt(data.data.time) / 60),
            sec: parseInt(parseInt(data.data.time) % 60)
        };
        State.testResult = {
            user_position: data.user_position,
            time: {
                min: time.min,
                sec: time.sec
            },
            score: data.data.score
        };
    },

    CLEAR_QUESTIONS(State) {
        State.questions = [];
    }

};

export default {
    namespaced: false,
    actions,
    state,
    getters,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/test.js